// Pick a MediaRecorder format the current browser can actually produce.
// iOS Safari does NOT support webm/opus — it records mp4 — and constructing
// MediaRecorder with an unsupported mimeType throws. The backend converts
// anything through ffmpeg, so any container these return is fine.
export function supportedAudioMimeType() {
  if (typeof MediaRecorder === 'undefined' || !MediaRecorder.isTypeSupported) return null
  return ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/mp4;codecs=mp4a.40.2']
    .find(t => MediaRecorder.isTypeSupported(t)) || null
}

export function newAudioRecorder(stream) {
  const mimeType = supportedAudioMimeType()
  return new MediaRecorder(stream, mimeType ? { mimeType } : undefined)
}
